import { isDef } from '..';
import { isNumeric } from '../validate/number';
export function addUnit(value) {
  if (!isDef(value)) {
    return undefined;
  }

  value = String(value);
  return isNumeric(value) ? value + "px" : value;
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/utils/format/unit.js
// module id = 302
// module chunks = 3